import React from 'react';
import styles from '../../styles/common/PendingTransactionIndicator.module.scss';

interface PendingTransactionIndicatorProps {
  pending_repayments?: number;
  pending_fee_repayments?: number;
  pending_withdraws?: number;
  type?: 'all' | 'repayment' | 'fee_payment' | 'withdrawal';
  className?: string;
}

const PendingTransactionIndicator: React.FC<PendingTransactionIndicatorProps> = ({
  pending_repayments = 0,
  pending_fee_repayments = 0,
  pending_withdraws = 0,
  type = 'all',
  className = ''
}) => {
  const formatAmount = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  // Convert to numbers
  const repaymentAmount = parseFloat(String(pending_repayments)) || 0;
  const feeAmount = parseFloat(String(pending_fee_repayments)) || 0;
  const withdrawAmount = parseFloat(String(pending_withdraws)) || 0;

  // Simple logic - show based on type
  if (type === 'withdrawal' && withdrawAmount > 0) {
    return (
      <div className={`${styles.pendingIndicator} ${className}`}>
        <div className={styles.pulsingIcon}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#E1652A" strokeWidth="2" fill="none" />
          </svg>
        </div>
        <div className={styles.messages}>
          <div className={styles.message}>
            Withdrawal pending: {formatAmount(withdrawAmount)}
          </div>
        </div>
      </div>
    );
  }

  if (type === 'repayment' && repaymentAmount > 0) {
    return (
      <div className={`${styles.pendingIndicator} ${className}`}>
        <div className={styles.pulsingIcon}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#E1652A" strokeWidth="2" fill="none" />
          </svg>
        </div>
        <div className={styles.messages}>
          <div className={styles.message}>
            Repayment pending: {formatAmount(repaymentAmount)}
          </div>
        </div>
      </div>
    );
  }

  if (type === 'fee_payment' && feeAmount > 0) {
    return (
      <div className={`${styles.pendingIndicator} ${className}`}>
        <div className={styles.pulsingIcon}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#E1652A" strokeWidth="2" fill="none" />
          </svg>
        </div>
        <div className={styles.messages}>
          <div className={styles.message}>
            Fee payment pending: {formatAmount(feeAmount)}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default PendingTransactionIndicator;
